import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function ArticleList() {
  const featured = articles.slice(0, 4);

  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3 whitespace-nowrap">
            精选文章
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            体育App使用攻略
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            深度评测、横向对比、使用技巧，帮你更好地使用体育App
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-secondary-200 transition-all duration-200 cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="w-full sm:w-48 h-44 sm:h-auto flex-shrink-0 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-5 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span
                        key={tag}
                        className="px-2 py-0.5 bg-secondary-50 text-secondary-700 rounded-md text-xs whitespace-nowrap"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                  <h3 className="font-semibold text-foreground-950 text-base group-hover:text-secondary-600 transition-colors mb-2 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span className="whitespace-nowrap">{article.date}</span>
                  <span className="whitespace-nowrap">{article.readTime}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/tiyu-zixun"
            className="inline-flex items-center gap-1.5 text-sm text-secondary-600 hover:text-secondary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            查看更多文章
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}